import { CSSProperties, useMemo } from 'react';
import { useContent } from 'src/contexts/ContentContext';
import { PosSelect } from 'src/core/POS/PosSelect';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';
import { UNDERCUT_REFERENCE_LISTING_POSITION_TO_CID } from 'src/utils/constants/contentIdMaps';
import { AutoPricingUndercutMode } from 'src/WebApiController';

import * as styles from '../AutoPricing.css';

const avgUndercutModeOptions = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
].reduce(
  (r, c) => {
    r[c] = c;
    return r;
  },
  {} as Record<string, string>
);

export const AutoPricingUnderCutReferenceListingPositionInput = ({
  undercutMode,
  undercutReferenceListingPosition,
  setUndercutReferenceListingPosition,
  rootStyle,
  disabled,
  direction = 'row',
}: {
  undercutMode: AutoPricingUndercutMode | null;
  undercutReferenceListingPosition: number | null;
  setUndercutReferenceListingPosition: (
    undercutReferenceListingPositionNew: number | null
  ) => void;
  rootStyle?: CSSProperties;
  disabled: boolean;
  direction?: 'row' | 'column';
}) => {
  const cheapestListingText = useContent(ContentId.CheapestListing);
  const cheapestListingsText = useContent(ContentId.CheapestListings);
  const excudingOutliersText = useContent(ContentId.ExcludingOutliers);
  const cheapestListingsExcludingOutliersText = useMemo(() => {
    const prefix =
      undercutMode === AutoPricingUndercutMode.AverageOfCheapestListings
        ? cheapestListingsText
        : cheapestListingText;

    return `${prefix} (${excudingOutliersText})`;
  }, [
    cheapestListingText,
    cheapestListingsText,
    excudingOutliersText,
    undercutMode,
  ]);

  const valueOptionsContent = useMemo(() => {
    return undercutMode === AutoPricingUndercutMode.AverageOfCheapestListings
      ? avgUndercutModeOptions
      : UNDERCUT_REFERENCE_LISTING_POSITION_TO_CID;
  }, [undercutMode]);

  return (
    <Stack direction={direction} gap={direction === 'row' ? 'l' : 'm'}>
      <PosSelect
        style={rootStyle ?? { width: '250px' }}
        value={undercutReferenceListingPosition?.toString() ?? undefined}
        disabled={disabled}
        valueOptionsContent={valueOptionsContent}
        enableEmptySelection={false}
        sortBy="key"
        onClick={(e) => e.stopPropagation()}
        onChange={(v) => {
          const newValue = parseInt(v);
          if (!isNaN(newValue)) {
            setUndercutReferenceListingPosition(newValue);
          }
        }}
      />

      <div className={styles.inlinePricingInputText}>
        {cheapestListingsExcludingOutliersText}
      </div>
    </Stack>
  );
};
